/**
 * Screen-reader announcements for results that show up somewhere else on the page (saved, copy
 * started, a port added): one polite live region that exists from the start, so what is written into
 * it is read out. A region that appears together with its text often isn't.
 *
 * The text is written a moment later: a dialog closing in the same step makes the rest of the page
 * inert until it's gone, and clearing first lets the same message ("Saved.") be read out twice.
 */

export const ANNOUNCER_ID = 'octbill-announcer';

let timer = null;

/** Creates the live region (once). Called at start-up, before anything is announced. */
export function mountAnnouncer(doc = globalThis.document) {
  if (!doc?.body) return null;
  let el = doc.getElementById(ANNOUNCER_ID);
  if (el) return el;
  el = doc.createElement('div');
  el.id = ANNOUNCER_ID;
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.setAttribute('aria-atomic', 'true');
  // Visually hidden, like Tailwind's sr-only.
  el.style.cssText =
    'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
  doc.body.append(el);
  return el;
}

/** Reads `text` out to screen-reader users (politely: after what they're hearing now). */
export function announce(text, doc = globalThis.document) {
  const el = mountAnnouncer(doc);
  if (!el) return;
  clearTimeout(timer);
  el.textContent = '';
  timer = setTimeout(() => {
    el.textContent = String(text ?? '');
  }, 150);
}
